import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCartAPI, getCartTotalAPI } from "../../../Store/Action/cartAction";
import { getLoggedInUserDetailsAPI } from "../../../Store/Action/UserAction";
import OrderWeightInfoPopup from "../Auth/MyAccount/CustomModals/OrderWeightInfoPopup";
import Footer from "../Layout/Footer/Footer";
import Header from "../Layout/Header/Header";
import "./Cart.css";
import EmptyCart from "./EmptyCart";
import LeftSideCart from "./leftSideCart";
import RightSideCart from "./RightSideCart";
import {
  createOrderAPI,
  getPaymentGatewayAPI,
  getPaymentMethodAPI,
} from "../../../Store/Action/orderAction";
import { getAddressLists } from "../../../Store/Action/addressAction";
import CustomLoader from "../CustomComponents/CustomLoader/CustomLoader";
import ShopByCategorySlider from "../ShopByCategorySlider";
import CheckoutComponent from "../CustomComponents/CheckoutComponent";
import { clearCart } from "../../../Store/Slice/cartSlice";
import { setCartItemCount } from "../../../Store/Slice/popupTriggerSlice";
import { toast } from "react-toastify";
import Icons from "../../../Config/Images";
import { resetWalletFlag } from "../../../Store/Slice/walletSlice";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation(); // already imported
  const manufacturerIdFromState = location.state?.manufacturer_id ?? null;

  const [billingAddress, setBillingAddress] = useState({});
  const [shippingAddress, setShippingAddress] = useState([]);
  const [processToCheckoutButtonDisable, setProcessToCheckoutButtonDisable] =
    useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [isLoading, SetIsLoading] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [totalAmountData, setTotalAmountData] = useState(0);
  const [isSameAddress, setIsSameAddress] = useState(() => {
    return sessionStorage.getItem("isSameAddress") === "true";
  });
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentGateway, setPaymentGateway] = useState([]);

  const liveRates = useSelector((state) => state.liveRate.rates);
  const isWastageEnabled = useSelector(
    (state) => state.wastage.isWastageEnabled,
  );

  const finalPayableAmount = useSelector(
    (state) => state.wallet.finalPayableAmount,
  );

  useEffect(() => {
    sessionStorage.setItem("isSameAddress", isSameAddress);
  }, [isSameAddress]);

  // const isCartEmpty = cartItems?.length === 0;

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  const handleProductClick = (productId) => {
    navigate(`/productDetail/${productId}`, { state: { productId } });
  };
  const onGetWishlist = useCallback(() => {
    fetchCart();
  }, []);

  //Fetch Cart function
  const fetchCart = useCallback(() => {
    dispatch(
      getCartAPI({ manufacturer_id: manufacturerIdFromState }, (result) => {
        if (result?.status) {
          setCartItems(Array.isArray(result?.data) ? result?.data : []);
          dispatch(setCartItemCount(result?.total_count || 0));
        }
        SetIsLoading(false);
      }),
    );
  }, [dispatch]);

  //fetch the cart items
  useEffect(() => {
    SetIsLoading(true);
    fetchCart();
  }, [dispatch]);

  // Refresh cart
  const getCartRefresh = () => {
    fetchCart();
  };

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        if (
          result?.data?.[0].global_cart_info?.find((e) => e?.product)?.product
            ?.length > 0
        ) {
          setIsPopupVisible(true);
        }
      }),
    );
  }, [dispatch]);

  const goldRate =
    liveRates.find((k) => k.metal?.toLowerCase() === "gold")?.rate || 0;

  const silverRate =
    liveRates.find((k) => k.metal?.toLowerCase() === "silver")?.rate || 0;

  const isRateAvailable = goldRate > 0;
  //  &&
  //  silverRate > 0;

  const refreshTotalAmount = () => {
    fetchCart();
  };
  useEffect(() => {
    if (!goldRate || !silverRate) return;
    const params = {
      gold_rate: goldRate,
      silver_rate: silverRate,
      manufacturer_id: manufacturerIdFromState,
    };
    dispatch(
      getCartTotalAPI(params, (result) => {
        setTotalAmountData(result?.data?.[0]?.advance_payment_value);
      }),
    );
  }, [goldRate, silverRate]);
  useEffect(() => {
    dispatch(
      getAddressLists({}, (result) => {
        setProcessToCheckoutButtonDisable(result?.data?.shipping_address);
        setShippingAddress(result?.data?.shipping_address);
        setBillingAddress(result?.data?.billing_address);
      }),
    );
  }, [dispatch]);

  const handleDirectCheckout = (walletOnly = false, paymentDetails = {}) => {
    if (processToCheckoutButtonDisable?.length === 0) {
      toast.error("Address required!");
      return;
    }

    const goldRate =
      liveRates.find((k) => k.metal?.toLowerCase() === "gold")?.rate || 0;

    const silverRate =
      liveRates.find((k) => k.metal?.toLowerCase() === "silver")?.rate || 0;

    const payload = {
      shipping_address_id: shippingAddress?.[0]?.user_address_id,
      billing_address_id: isSameAddress
        ? shippingAddress?.[0]?.user_address_id
        : billingAddress?.user_address_id,
      live_rates: {
        gold: goldRate,
        silver: silverRate,
      },
      manufacturer_id: manufacturerIdFromState,

      // ✅ only send if exists
      ...(paymentDetails?.payment_gateway_id && {
        payment_gateway_id: paymentDetails.payment_gateway_id,
      }),
      ...(paymentDetails?.payment_method_id && {
        payment_method_id: paymentDetails.payment_method_id,
      }),
    };

    dispatch(
      createOrderAPI(payload, (result) => {
        if (!result?.data?.status) {
          toast.error("Something went wrong!");
          return;
        }

        // 🟢 Wallet full payment
        if (walletOnly) {
          toast.success("Order Placed Successfully!");

          dispatch(resetWalletFlag());
          dispatch(clearCart());
          fetchCart();
          navigate("/my-account/my-orders");

          return;
        }

        const order = result.data.data;

        // 🟡 If backend did NOT return Razorpay order → treat as manual
        if (!order?.id) {
          toast.success("Order placed successfully!");
          dispatch(clearCart());
          navigate("/my-account/my-orders");
          return;
        }

        // 🟡 Razorpay Flow
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY,
          amount: order.amount,
          currency: order.currency,
          name: "Zabali Jewelex",
          description: "Order Payment",
          image: Icons.zabali_header_logo_icon,
          order_id: order.id,

          handler: function () {
            toast.success("Payment Successful!");
            dispatch(resetWalletFlag());
            dispatch(clearCart());
            fetchCart();
            navigate("/my-account/my-orders");
          },

          modal: {
            ondismiss: function () {
              toast.error("Payment Cancelled!");
              navigate("/my-account/my-orders");
            },
          },
        };

        const rzp = new window.Razorpay(options);

        rzp.on("payment.failed", function () {
          toast.error("Payment Failed!");
        });

        rzp.open();
      }),
    );
  };

  const handleContinueClick = () => {
    if (finalPayableAmount <= 0) {
      handleDirectCheckout(true);
      return;
    }

    // ✅ Always open modal now
    setIsPaymentModalOpen(true);
  };

  const handleUPIPayment = () => {
    setIsPaymentModalOpen(false);
    handleDirectCheckout();
  };

  const handleCloseModal = () => {
    fetchCart();
    setIsModalOpen(false); // Close modal
  };

  const onFetchUserAddress = useCallback(() => {
    try {
      dispatch(
        getAddressLists({}, (result) => {
          setBillingAddress(result?.data?.billing_address || null);

          const filteredShipping =
            result?.data?.shipping_address?.filter(
              (address) => address?.defaultaddress,
            ) || [];

          setShippingAddress(filteredShipping);
          setProcessToCheckoutButtonDisable(result?.data?.shipping_address);
        }),
      );
    } catch (error) {}
  }, [dispatch]);

  const hasMultipleManufacturers = useMemo(() => {
    if (!cartItems?.length) return false;
    const unique = new Set(cartItems.map((i) => i?.manufacturer_id));
    return unique.size > 1;
  }, [cartItems]);

  useEffect(() => {
    dispatch(
      getPaymentMethodAPI({}, (res) => {
        setPaymentMethods(res || []);
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getPaymentGatewayAPI({}, (res) => {
        setPaymentGateway(res || []);
      }),
    );
  }, [dispatch]);

  const handleDynamicPayment = (method) => {
    setIsPaymentModalOpen(false);

    const methodName = method.payment_method_name?.toLowerCase();

    // ✅ 1. UPI → Razorpay
    if (methodName === "upi") {
      const selectedGateway = paymentGateway.find(
        (g) => g.payment_gateway_name?.toLowerCase() === "razorpay",
      );

      if (!selectedGateway) {
        toast.error("Payment gateway not available");
        return;
      }

      handleDirectCheckout(false, {
        payment_gateway_id: selectedGateway.payment_gateway_id,
        payment_method_id: method.payment_method_id,
      });

      return;
    }

    // ✅ 2. RTGS → ONLY navigate (NO API)
    if (methodName === "rtgs") {
      const selectedGateway = paymentGateway.find(
        (g) => g.payment_gateway_name?.toLowerCase() === "manual",
      );

      if (!selectedGateway) {
        toast.error("Payment gateway not available");
        return;
      }

      navigate("/payment-card", {
        state: {
          dueAmount: finalPayableAmount,
          payment_method_id: method.payment_method_id,
          payment_gateway_id: selectedGateway.payment_gateway_id,
          manufacturer_id: manufacturerIdFromState,
        },
      });

      return;
    }

    // ✅ 3. CASH → Direct order
    if (methodName === "cash") {
      const selectedGateway = paymentGateway.find(
        (g) => g.payment_gateway_name?.toLowerCase() === "manual",
      );

      if (!selectedGateway) {
        toast.error("Payment gateway not available");
        return;
      }

      const payload = {
        shipping_address_id: shippingAddress?.[0]?.user_address_id,
        billing_address_id: isSameAddress
          ? shippingAddress?.[0]?.user_address_id
          : billingAddress?.user_address_id,
        live_rates: {
          gold: goldRate,
          silver: silverRate,
        },
        payment_gateway_id: selectedGateway.payment_gateway_id,
        payment_method_id: method.payment_method_id,
        manufacturer_id: manufacturerIdFromState,
      };

      dispatch(
        createOrderAPI(payload, (res) => {
          if (!res?.status) {
            toast.error("Something went wrong!");
            return;
          }

          toast.success("Order placed successfully!");
          dispatch(clearCart());
          navigate("/my-account/my-orders");
        }),
      );

      return;
    }
  };

  const filteredPaymentMethods = useMemo(() => {
    if (!paymentMethods?.length) return [];
    if (finalPayableAmount <= 100000) {
      return paymentMethods.filter((method) => {
        const name = method.payment_method_name?.toLowerCase();
        return name !== "cash";
      });
    }
    // 💡 Above 1 lakh → only RTGS & CASH
    if (finalPayableAmount > 100000) {
      return paymentMethods.filter((method) => {
        const name = method.payment_method_name?.toLowerCase();
        return name === "rtgs" || name === "cash";
      });
    }

    // 💡 Otherwise → show all
    return paymentMethods;
  }, [paymentMethods, finalPayableAmount]);

  return (
    <>
      <div className="cartMainDiv">
        <Header />
        {/* <div style={{height:"100px"}}>

        </div> */}
        {isLoading ? (
          <>
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          </>
        ) : cartItems?.length == 0 ? (
          <>
            <EmptyCart />
            {/* <ShopByCategorySlider /> */}
            <Footer />
          </>
        ) : (
          <>
            <div className="cart-main-width">
              <div className="cart-left-div">
                <p className="shopping-cart-title">Shopping Cart</p>
                {cartItems?.map((item, index) => (
                  <LeftSideCart
                    key={item.product_id}
                    imageSrc={`${item?.product_image?.product_image_url}`}
                    productName={item.product_name}
                    productCode={item?.product_code}
                    netWeight={item.product_net_weight}
                    wastage={item.product_wastage}
                    initialQuantity
                    product={item}
                    cartFlag={true}
                    getCartRefresh={getCartRefresh}
                    onClick={() => handleProductClick(item.product_id)}
                    onGetWishlist={onGetWishlist}
                    refreshTotalAmount={refreshTotalAmount}
                    isWastageEnabled={isWastageEnabled} // ✅ Passing isWastageEnabled
                  />
                ))}
              </div>

              <div className="cart-right-div">
                <p className="select-cart-title">Select Address</p>
                <RightSideCart
                  isSameAddress={isSameAddress}
                  setIsSameAddress={setIsSameAddress}
                  totalAmount={totalAmountData}
                  refreshAddressInCart={onFetchUserAddress}
                  // addressDataByLocationState={addressDataByLocationState}
                  manufacturerId={manufacturerIdFromState}
                />
              </div>
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      {/* <div className="footer-in-cart"><Footer /></div> */}
      {/* Show the OrderWeightInfoPopup if isPopupVisible is true */}

      {cartItems?.length > 0 && (
        <div className="checkout-in-cart">
          <div className="checkout-in-cart-left-side-div checkout-para">
            {/* <p>Advance Amount : </p>
            <p>{` ${totalAmountData?.advance_payment_value || 0}`}/-</p> */}
          </div>
          {/* <button className="btn-checkout-view">
            <p className="checkout-text-style">Process to Checkout</p>
          </button> */}
          <div className="btn-checkout-view">
            <button
              className={`checkout-text-style ${
                processToCheckoutButtonDisable?.length === 0 || !isRateAvailable
                  ? "disable-checkout-btn"
                  : ""
              }`}
              // disabled={
              //   processToCheckoutButtonDisable?.length === 0 || isRateAvailable
              // }
              onClick={() => {
                if (!isRateAvailable) {
                  toast.error(
                    "Live rates not available. Please try again later.",
                  );
                  return;
                }

                if (hasMultipleManufacturers) {
                  toast.error(
                    "We can process only one brand at a time. Please remove items from other brands to checkout.",
                  );
                  return;
                }

                if (processToCheckoutButtonDisable?.length > 0) {
                  handleContinueClick();
                } else {
                  toast.error("Address required!");
                }
                // handleContinueClick();
              }}
            >
              {/* Continue */}
              Place Order
            </button>
          </div>
        </div>
      )}
      {/* ✅ Modal Component */}
      {isModalOpen && (
        <CheckoutComponent
          shippingAddress={shippingAddress}
          billingAddress={billingAddress}
          isSameAddress={isSameAddress}
          onClose={handleCloseModal}
          totalAmountData={totalAmountData}
          closeThePopUp={handleCloseModal}
          manufacturer_id={manufacturerIdFromState}
        />
      )}
      {/* {isPopupVisible && <OrderWeightInfoPopup onClose={handleClosePopup} />} */}
      {isPaymentModalOpen && (
        <div className="payment-modal-backdrop">
          <div className="payment-modal">
            <h3>Choose Payment Method</h3>
            <div className="payment-options">
              {filteredPaymentMethods.map((method) => (
                <div
                  key={method.payment_method_id}
                  className="payment-option-card"
                  onClick={() => handleDynamicPayment(method)}
                >
                  <img
                    style={{ width: "80px" }}
                    src={method.payment_method_url} // ✅ from backend
                    alt={method.payment_method_name}
                  />
                  <p>{method.payment_method_name}</p>
                  {/* Optional */}
                  {/* <small>{method.payment_method_description}</small> */}
                </div>
              ))}
            </div>

            <button
              className="cancel-btn"
              onClick={() => setIsPaymentModalOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Cart;
